module.exports = __webpack_public_path__ + "static/key-sunlessbundle-6e2af45389fff7fd497becd6f31192ca.webp";